export const BASE_URL = window.ENV_SERVICE_BASEURL;